import { Component, ViewContainerRef } from '@angular/core';
import { DynamicPage } from '../../models/widget/dynamic-page.model';
import { CategoryService } from '../../services/category/category.service';
import { BrandService } from '../../services/brand/brand.service';
import { ToastsManager } from 'ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
import { WidgetTemplate } from '../../models/widget/widget-template.model';
import { MobilewidgetService } from '../../services/widget/mobilewidget.service';
import { PageWidget } from '../../models/widget/page-widget.model';
import { DisplayCategory } from '../../models/category/DisplayCategory.model';
import { WidgetContent } from '../../models/widget/widget-content.model';
import { Brand } from '../../models/brand/brand-model';
import { Customer } from '../../models/customer/customer-model';

@Component({
  selector: 'app-mobile-page-widget-list',
  templateUrl: './mobile-page-widget-list.component.html',
  styleUrls: ['./mobile-page-widget-list.component.css']
})
/** mobile-page-widget-list component*/
export class MobilePageWidgetListComponent {

  public dynamicPageList: DynamicPage[];
  public widgetTemplateList: WidgetTemplate[];
  public pageWidgetList: PageWidget[];
  multipleWidgetItems: MultipleWidgetItems[] = [];
  public widgetContentList: WidgetContent[] = [];
  public categoryList: DisplayCategory[] = [];
  public pageWidget = new PageWidget();
  public Brands: Brand[];
  public ProductList: WidgetProducts[] = [];
  public vendors: Customer[];
  customDPage: string;
  widgetTemplateID: number;
  selectedBannerImage: string[];
  BannerImageOverText: string[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  selectedFlashSaleBannerImage: string[];
  selectedILoveAppBannerImage: string[];
  saleStartDate: string[];
  saleEndDate: string[];
  /** mobile-page-widget-list ctor */
  constructor(private readonly widgetService: MobilewidgetService,
    private readonly categoryService: CategoryService,
    private readonly brandsService: BrandService,
    private readonly toastr: ToastsManager,
    vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.GetDynamicPages();
    this.GetWidgetTemplates();
    this.GetAllDisplayCategoryList();
    this.GetAllBrands();
    this.FetchAllCategoriesProducts();
    this.GetBestVendors();
    this.customDPage = "1";
    this.widgetTemplateID = 0;
    setTimeout(() => {
      this.LaodSavedWidgets();
    }, 5000);

  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("mobilepageWidget").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {



          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  GetDynamicPages() {
    this.widgetService.GetDynamicPages().subscribe(
      data => {
        this.dynamicPageList = data;
      }
    )
  }
  GetWidgetTemplates() {
    this.widgetService.GetWidgetTemplates().subscribe(
      data => {
        this.widgetTemplateList = data;
      }
    )
  }
  GetAllDisplayCategoryList() {
    this.categoryService.GetAllDisplayCategoryList().subscribe(
      data => {
        this.categoryList = data;
        //this.subCategoryList = this.categoryList.filter(s => s.isParent == false);
      }
    )
  }
  GetAllBrands() {
    this.brandsService.getBrand().subscribe(
      data => {
        this.Brands = data;
      });
  }
    GetBestVendors() {
    this.widgetService.GetBestVendors().subscribe(
      data => {
        this.vendors = data;
      });
  }
  FetchAllCategoriesProducts() {
    this.widgetService.FetchAllCategoriesProducts().subscribe(
      data => {
        this.ProductList = data;
      }
    )
  }
  WidgetContentInitialization() {
    //this.selectedCategoryImage = [];
    //this.selectedBrandImageLeft = [];
    //this.selectedBrandImageRight = [];
    this.pageWidget = new PageWidget();
    this.widgetContentList = [];
    //this.selectedPopualarCategoryIds = [];
    this.selectedBannerImage = [];
    this.selectedFlashSaleBannerImage = [];
    this.saleStartDate = [];
    this.saleEndDate = [];
    this.BannerImageOverText = [];
    this.selectedILoveAppBannerImage = [];

  }
  LaodSavedWidgets() {
    this.WidgetContentInitialization();
    this.widgetService.GetSortedPageWidgetsByPageID(parseInt(this.customDPage), this.widgetTemplateID).subscribe(
      data => {
        this.pageWidgetList = data;
        for (var p = 0; p < this.pageWidgetList.length; p++) {
          //Intialization of Multiple widgets
          this.multipleWidgetItems[p] = new MultipleWidgetItems();
          // For Popular Category Widget
          this.multipleWidgetItems[p].popularCategoryList = [];
          // For Popular Brand Widget
          this.multipleWidgetItems[p].popularBrands = [];
          // For Category Products
          this.multipleWidgetItems[p].CategoryProducts = [];
          // For Top Vendors
          this.multipleWidgetItems[p].topVendors = [];
          // For Top Category Widget
          this.multipleWidgetItems[p].topCategoryList = [];

          this.pageWidget.widgetTemplateID = this.pageWidgetList[p].widgetTemplateID;
          this.pageWidget.sortOrder = this.pageWidgetList[p].sortOrder;
          this.pageWidget.pageWidgetID = this.pageWidgetList[p].pageWidgetID;

          // retaining PageWID To check product widget
          //end for product widget
          this.pageWidget.id = this.pageWidgetList[p].id;
          this.widgetContentList = this.pageWidgetList[p].widgetContentList;
          var widgetTemplate = this.widgetTemplateList.find(s => s.widgetTemplateID == this.pageWidgetList[p].widgetTemplateID)
          if (widgetTemplate != null) {
            if (widgetTemplate.widgetType == WidgetTypes.PopularCategoryMobile.toString()) {
              for (var popularCatIndex = 0; popularCatIndex < this.widgetContentList.length; popularCatIndex++) {
                let arrThumbnailCatIds = this.CommaSpliter(this.widgetContentList[popularCatIndex].data);
                for (var i = 0; i < arrThumbnailCatIds.length; i++) {
                  var selectedPopularCategory = this.categoryList.find(s => s.categoryID == parseInt(arrThumbnailCatIds[i]));
                  this.multipleWidgetItems[p].popularCategoryList.push(selectedPopularCategory);
                }
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.PopularBrands.toString()) {
              for (var popularBrandIndex = 0; popularBrandIndex < this.widgetContentList.length; popularBrandIndex++) {
                let arrBrandIds = this.CommaSpliter(this.widgetContentList[popularBrandIndex].data);
                for (var i = 0; i < arrBrandIds.length; i++) {
                  var selectedbrand = this.Brands.find(s => s.brandID == parseInt(arrBrandIds[i]));
                  this.multipleWidgetItems[p].popularBrands.push(selectedbrand);
                }
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.BannerMobile.toString()) {
              for (var bannerIndex = 0; bannerIndex < this.widgetContentList.length; bannerIndex++) {
                //new data structure => TextBit~date|url,path
                let overTextAndUrlImage = this.PipeSignSpliter(this.widgetContentList[bannerIndex].data);
                let arrUrlAndImage = this.CommaSpliter(overTextAndUrlImage[1]);
                this.selectedBannerImage[p] = "Images/MobileWidgetContentImages/" + arrUrlAndImage[1];
                this.BannerImageOverText[p] = this.TildSpliter(overTextAndUrlImage[0])[1];
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.FirstLevelCategory.toString()) {
              for (var catIndex = 0; catIndex < this.widgetContentList.length; catIndex++) {
                let categoryID = parseInt(this.widgetContentList[catIndex].data);
                var products = this.ProductList.filter(s => s.categoryID == categoryID);
                this.multipleWidgetItems[p].CategoryProducts = products;
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.BestVendor.toString()) {
              for (var vendorIndex = 0; vendorIndex < this.widgetContentList.length; vendorIndex++) {
                let arrVendorIds = this.CommaSpliter(this.widgetContentList[vendorIndex].data);
                for (var i = 0; i < arrVendorIds.length; i++) {
                  var selectedVendor = this.vendors.find(s => s.customerID == parseInt(arrVendorIds[i]));
                  if (selectedVendor != null) {
                    this.multipleWidgetItems[p].topVendors.push(selectedVendor);
                  }
                }
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.TopCategory.toString()) {
              for (var topCatIndex = 0; topCatIndex < this.widgetContentList.length; topCatIndex++) {
                let arrThumbnailCatIds = this.CommaSpliter(this.widgetContentList[topCatIndex].data);
                for (var i = 0; i < arrThumbnailCatIds.length; i++) {
                  var selectedTopCategory = this.categoryList.find(s => s.categoryID == parseInt(arrThumbnailCatIds[i]));
                  this.multipleWidgetItems[p].topCategoryList.push(selectedTopCategory);
                }
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.FlashSaleBanner.toString()) {
              for (var bannerIndex = 0; bannerIndex < this.widgetContentList.length; bannerIndex++) {
                //new data structure => url,path|SaleStartDate,SaleEndDate
                let urlImageAndSaleDate = this.PipeSignSpliter(this.widgetContentList[bannerIndex].data);
                let arrUrlAndImage = this.CommaSpliter(urlImageAndSaleDate[0]);
                //this.flashSaleBannerImageRedirectUrl = arrUrlAndImage[0];
                this.selectedFlashSaleBannerImage[p] = "Images/MobileWidgetContentImages/" + arrUrlAndImage[1];
                let saleDates = this.CommaSpliter(urlImageAndSaleDate[1]);
                this.saleStartDate[p] = this.formatDate(saleDates[0]);
                this.saleEndDate[p] = this.formatDate(saleDates[1]);
                //this.TimeCountDown(saleDates[1]);
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.SendMeApp.toString()) {
              for (var bannerIndex = 0; bannerIndex < this.widgetContentList.length; bannerIndex++) {
                this.selectedILoveAppBannerImage[p] = "Images/MobileWidgetContentImages/" + this.widgetContentList[bannerIndex].data;
              }
            }
          }
        }
      });
  }
  deleteWidget(id) {
    var ans = confirm("Are you sure to delete this Widget? ");
    if (ans) {
      this.widgetService.DeletePageWidget(id);
      this.toastr.success('Widget deleted successfully.', 'Success');
      setTimeout(() => {
        this.LaodSavedWidgets();
      }, 2000);
    }
  }
  //common functions
  formatDate(date: string): string {
    let newDate = new Date(date);
    let days = newDate.getDate();
    let months = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    return months + "/" + days + "/" + year;
  }
  PipeSignSpliter(str: string): string[] {
    return str != "" ? str.toString().split('|') : [];
  }

  ColonSpliter(str: string): string[] {
    return str != "" ? str.toString().split(':') : [];
  }
  CommaSpliter(str: string): string[] {
    return str != "" ? str.toString().split(',') : [];
  }
  TildSpliter(str: string): string[] {
    return str != "" ? str.toString().split('~') : [];
  }
}

enum WidgetTypes {
  PopularCategoryMobile = "PopularCategoryMobile",
  Products = "Products",
  PopularBrands = "PopularBrands",
  BestVendor = "TopVendors",
  BannerMobile = "BannerMobile",
  FirstLevelCategory = "FirstLevelCategory",
  TopCategory = "TopCategory",
  FlashSaleBanner = "FlashSaleBanner",
  SendMeApp = "SendMeApp",
}
// For showing multiple widgets
export class MultipleWidgetItems {
  public popularCategoryList: DisplayCategory[] = [];
  public popularBrands: Brand[] = [];
  public CategoryProducts: WidgetProducts[] = [];
  public topVendors: Customer[] = [];
  public topCategoryList: DisplayCategory[] = [];

}
export class WidgetProducts {
  public categoryID: number;
  public url: string;
  public path: string;
  public name: string;
  public productName: string;
  public salePrice: number;
  public regularPrice: number;
  public productDefaultImage: string;
}



// WEBPACK FOOTER //
// ./src/app/widget-mobile/mobile-page-widget-list/mobile-page-widget-list.component.ts